import * as Sentry from "@sentry/nextjs";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { useSWRConfig } from "swr";

import { useErrorToaster } from "src/common/components/ErrorDetails";
import { client, endpoint } from "src/lib/bridgeClient";
import { SERVER_COMM_ERROR } from "src/lib/error";

export type UpdateWorkflowDTO = {
  masterNode?: string;
  head_node_instance_type?: string;
  compute_instance_type?: string;
  initial_queue_size?: number;
  max_queue_size?: number;
  maintain_initial_size?: boolean;
  access_from: string;
};

export const patchWorkflow = async (client: Client, id: string, workflow: UpdateWorkflowDTO) => {
  return await client(endpoint.patchWorkflow(encodeURIComponent(id)), "PATCH", workflow);
};

export const useUpdateWorkflow = () => {
  const toastError = useErrorToaster();
  const { mutate } = useSWRConfig();

  return async (id: string, name: string, workflow: UpdateWorkflowDTO): Promise<AxiosResponse> => {
    let response: AxiosResponse;

    try {
      response = await patchWorkflow(client, id, workflow);

      mutate(endpoint.workflows);

      toast.success(`Workflow updated: ${name}`);
    } catch (error) {
      if (error?.response?.data?.error) {
        toastError("Failed to update workflow", error?.response?.data?.error);
      } else {
        toast.error(`Request failed: ${SERVER_COMM_ERROR}`);
        Sentry.captureException(error);
      }

      return error.response;
    }

    return response;
  };
};
